const fs = require("fs");
const path = require("path");
const vm = require("vm");

const folder = __dirname;
const ignore = new Set(["sortTranslations.js", "index.js", "update-i18n.js", path.basename(__filename)]);

function getAllKeys(obj, prefix = "") {
	let keys = [];
	for (const k in obj) {
		const full = prefix + k;
		if (obj[k] && typeof obj[k] === "object") {
			keys = keys.concat(getAllKeys(obj[k], full + "."));
		} else {
			keys.push(full);
		}
	}
	return keys;
}

function loadTranslations(filePath) {
	const src = fs.readFileSync(filePath, "utf8");
	const wrapped = src.replace(/export\s+default/, "module.exports =");
	const sandbox = { module: { exports: {} } };
	vm.createContext(sandbox);
	vm.runInContext(wrapped, sandbox, { filename: filePath });
	return sandbox.module.exports;
}

const maps = {};

fs.readdirSync(folder)
	.filter((f) => f.endsWith(".js") && !ignore.has(f))
	.forEach((f) => {
		try {
			const data = loadTranslations(path.join(folder, f));
			maps[f] = new Set(getAllKeys(data));
		} catch (e) {
			console.error(`❌ ${f}: ${e.message}`);
		}
	});

const allKeys = new Set();
Object.values(maps).forEach((set) => set.forEach((k) => allKeys.add(k)));

for (const [file, set] of Object.entries(maps)) {
	const missing = [...allKeys].filter((k) => !set.has(k));
	if (missing.length) {
		console.log(`❌ ${file} is missing ${missing.length} keys:`);
		missing.forEach((k) => console.log("  -", k));
	} else {
		console.log(`✅ ${file} has all keys.`);
	}
}
